<template>
    <FormKit
        type="form"
        :value="{
            cnh_renach:'',
            observation:'',
        }"
        submit-label="Continuar"
        @submit="confirmData"
        >
            <template #submit>
                <FooterButton/>
            </template>

            <h2 class="text-xl font-bold mb-1">Insira seus dados</h2>

            <FormKit
                type="text"
                name="cnh_renach"
                label="Número da renach*"
                maxlength="20"
                validation="required"
                :validation-messages="{
                  required: 'O número da renach é obrigatório'
                }"
            />
        </FormKit>
  </template>
<script>
import FooterButton from '../../components/FooterButton.vue'
import { ref } from 'vue'
import { useStore } from '../../../stores/cadastro.js'
import { useRouter } from 'vue-router'

export default {
    components: {
        FooterButton,
    },
    data(){
        return{
            cnh_renach: '',
        }
    },
    setup() {
        const router = useRouter();
        const store = useStore();

        const confirmData = async (formData) => {
            await store.updateDocumentationsData(formData);
            router.push({ name: 'UploadCnh' })
        }

        return {
            confirmData,
        };
    },
}
</script>
